module.exports = __webpack_public_path__ + "static/media/icon-google-color.991f70ec.svg";